import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FadeInImage = ({ src, alt, width, height, onClick }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <motion.img
            src={src}
            alt={alt}
            width={width}
            height={height}
            onClick={onClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: isLoaded ? 1 : 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            onLoad={() => setIsLoaded(true)}
            style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                objectFit: 'cover'
            }}
        />
    );
};

export default FadeInImage;
